var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00014 8.17853L12.2442 13.4226L13.4227 12.2441L8.17865 7.00002L13.4227 1.75598L12.2442 0.57747L7.00014 5.82151L1.75603 0.577393L0.577515 1.7559L5.82163 7.00002L0.577515 12.2441L1.75603 13.4226L7.00014 8.17853Z",
    fill: "#606060"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "assets/08d8fdd3.svg";